import React from 'react';

/**
 * ErrorBoundary - Catches rendering errors in child components
 * and displays a fallback UI instead of crashing the entire app.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg m-4 max-w-2xl mx-auto">
          <h3 className="text-red-800 dark:text-red-200 font-semibold mb-2">Something went wrong</h3>
          <p className="text-red-600 dark:text-red-300 text-sm mb-4">An error occurred. Please try again.</p>
          <button onClick={this.handleRetry} className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 text-sm">
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
